<template lang="html">
  <div class="loader">
    <v-image class="loader-image" src="static/loader.svg" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.loader {
  // border: 4px solid color(primary);
  padding: 20px;
  // border-radius: 50%;
  .loader-image {
    display: block;
    margin: 0 auto;
    width: 56px;
    height: 56px;
    animation: spinner linear 1s infinite;
    fill: color(primary);
  }
}
@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/components/loader.vue